import { c as _c } from "react/compiler-runtime";
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
import useScreen from 'hooks/useScreen';
import IconCamera from '../../../../icons/iconCamera';
const PDPCustomerPhotosGridUI = t0 => {
  const $ = _c(12);
  const {
    photos,
    totalPhotos,
    onPhotoClick
  } = t0;
  const {
    isMobile,
    isDesktop
  } = useScreen();
  if (!photos || !photos.length) {
    return null;
  }
  let t1;
  if ($[0] !== isDesktop || $[1] !== isMobile || $[2] !== onPhotoClick || $[3] !== photos || $[4] !== totalPhotos) {
    const items = photos.slice(0, 5);
    t1 = items.map((photo, idx) => <div key={photo.id} className={cx({
      "flex-[1_1_0%] min-w-[75%] pr-5": isMobile,
      "col-start-1 col-end-3 row-start-1 row-end-3": items.length !== 3 && !isMobile && idx === 0,
      "col-start-1 col-end-4": items.length === 3 && !isMobile && idx === 0,
      "col-start-3 col-end-5": items.length === 4 && !isMobile && idx === 1,
      "col-start-3 col-end-5 row-start-1 row-end-3": items.length === 2 && !isMobile && idx === 1
    })}><div className={cx({
        "h-0 mb-0 overflow-hidden pt-[100%] relative [&_img]:absolute [&_img]:inset-0 [&_img]:w-full [&_img]:h-full": isMobile,
        "w-full h-full": !isMobile
      })}>{photos.length > 5 && idx === 4 ? <button type="button" className={cx("w-full h-full flex cursor-pointer items-center justify-center flex-col bg-brand-lightest transition-[background-color_.15s_ease] [&_svg_g]:fill-brand hover:bg-brand-lighter", {
          "absolute inset-0": isMobile
        })} onClick={onPhotoClick}><div><IconCamera /></div>{totalPhotos > 4 && <div className="text-xs text-brand">+{totalPhotos - 4} more</div>}</button> : <JBImage sizes="50vw" src={photo.url} ar="1:1" fit="crop" trim="auto" onClick={() => onPhotoClick(idx)} className={cx({
          rounded: isMobile,
          "hover:cursor-target": isDesktop
        })} />}</div></div>);
    $[0] = isDesktop;
    $[1] = isMobile;
    $[2] = onPhotoClick;
    $[3] = photos;
    $[4] = totalPhotos;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const children = t1;
  if (isMobile) {
    let t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        navType: "Button",
        visibleSlides: 2,
        imageWidth: 150,
        infinite: false
      };
      t3 = {
        value: "Component"
      };
      $[6] = t2;
      $[7] = t3;
    } else {
      t2 = $[6];
      t3 = $[7];
    }
    let t4;
    if ($[8] !== children) {
      t4 = <div className="max-[767px]:-ml-5 max-[767px]:-mr-5"><ImageSliderStandard config={{
          children,
          sliderConfig: t2,
          variation: t3
        }} fullWidth={true} /></div>;
      $[8] = children;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t2;
  if ($[10] !== children) {
    t2 = <div className="grid gap-[.5rem] mt-4 mb-2 grid-cols-[repeat(4,calc(25%_-_.5rem)_)] grid-rows-[repeat(2,100px)] justify-center content-end [content-visibility:auto] [contain-intrinsic-size:0]">{children}</div>;
    $[10] = children;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
PDPCustomerPhotosGridUI.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    url: PropTypes.string
  })),
  totalPhotos: PropTypes.number,
  onPhotoClick: PropTypes.func
};
export default PDPCustomerPhotosGridUI;